import pageMetadata from '../page-metadata';

/**
 * @param {string} path
 * @returns {null | import("../page-metadata").PageMetadata} ...
 */
export function pageMetadataForPath(path) {
	const path2 = path.replace(/(^[/ ]+)|([/ ]+$)/g, '');
	const path3 = path2.length === 0 ? '/' : `/${path2}/`;
	return typeof pageMetadata[path3] === 'undefined' ? null : pageMetadata[path3];
}
